//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'PageSubFooter',
  props: {
    copyrightOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      currencyCode: 'store/currency'
    }),
    items () {
      return [
        { label: 'Cookies', action: this.showCookieModal },
        { label: 'Privacy', action: this.openPrivacyPolicy },
        { label: 'Terms', action: this.openTermsAndConditions },
        { label: 'Klarna', target: '/klarna-faqs' }
      ]
    }
  },
  methods: {
    handleClick (item) {
      if (item.action) return item.action()
    },
    showCookieModal () {
      this.$store.commit('page/SET_COOKIE_MODAL_STATE', true)
    },
    showCurrencyMenu () {
      this.$store.commit('page/TOGGLE_CURRENCY_MENU')
    },
    openPrivacyPolicy () {
      this.openSidebarPage('privacy-policy')
    },
    openTermsAndConditions () {
      this.openSidebarPage('terms-and-conditions')
    },
    openSidebarPage (slug) {
      this.$store.dispatch('sidebar/OPEN_SIDEBAR_PAGE', { slug })
    }
  }
}
